import { PCSOInput, PCSOInputProps } from 'components/pcso/form/PCSOInput';

export const PCSOInputDisabled = ({ control, name, value = 0 }: PCSOInputProps) => {
	return <PCSOInput readOnly disabled control={control} name={name} value={value} />;
};
